import { Trans } from '@/components'

import { ModelRoute } from '../types'

interface RouteOverviewProps {
  route: ModelRoute
}

export function RouteOverview({ route }: RouteOverviewProps) {
  return (
    <div className="bg-panel-gray-100 rounded-lg grid grid-cols-4 gap-y-4 gap-x-4 p-4 t-sm text-tertiary">
      <div className="space-y-1">
        <div className="t-xs text-secondary">
          <Trans ns="modelRoute" i18nKey="detail.overview.id">
            ID
          </Trans>
        </div>
        <div className="t-sb text-primary">{route.resID}</div>
      </div>
      <div className="space-y-1">
        <div className="t-xs text-secondary">
          <Trans ns="modelRoute" i18nKey="detail.overview.routeName">
            Route Name
          </Trans>
        </div>
        <div className="t-sb text-primary break-all">{route.name}</div>
      </div>
      <div className="space-y-1">
        <div className="t-xs text-secondary">
          <Trans ns="modelRoute" i18nKey="detail.overview.createdAt">
            Created At
          </Trans>
        </div>
        <div className="t-sb text-primary">{route.createdAt}</div>
      </div>
      <div className="space-y-1">
        <div className="t-xs text-secondary">
          <Trans ns="modelRoute" i18nKey="detail.overview.lastModified">
            Last Modified
          </Trans>
        </div>
        <div className="t-sb text-primary">{route.lastModified}</div>
      </div>
      <div className="space-y-1 col-span-4">
        <div className="t-xs text-secondary">
          <Trans ns="modelRoute" i18nKey="detail.overview.description">
            Route description
          </Trans>
        </div>
        <div className="t-sb text-primary break-all whitespace-pre-wrap">{route.description}</div>
      </div>
    </div>
  )
}
